<template>
    <div>
        <header>
            <div id="top">
                <div id="title-resource">
                    <a accesskey="1" href="https://www.wohnungsdatenbank.uni-freiburg.de" class="resource" title="Wohnungsdatenbank">Wohnungsdatenbank</a>
                </div>
                <div id="title-uni">
                    <a href="https://www.uni-freiburg.de/" title="Albert-Ludwigs-Universität Freiburg" target="_blank">Albert-Ludwigs-Universität Freiburg</a>
                </div>
            </div>
            <div id="red-bar">
            </div>
        </header>
    </div>

</template>

<script>
    export default {
        props: {
        },
    };
</script>
